import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit,ChangeDetectorRef } from '@angular/core';
import {FormBuilder, FormGroup,FormArray, Validators} from "@angular/forms";
import {Router, ActivatedRoute} from "@angular/router";
import { Da7420ServiceService } from '../../../../../Service/da7420/da7420-service.service';
import { from } from 'rxjs';
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
//import { LayoutUtilsService } from 'src/app/core/_base/crud';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe} from '@angular/common';
import { Ba1300Class } from '../../../../../Class/ba1300/ba1300-class';
import { EmployeeListClass } from '../../../../../Class/common/employee-list/employee-list-class';
import { EmployeeListComponent } from '../../../../pages/Hrms/common/employee-list/employee-list.component';
import { Alert } from 'selenium-webdriver';
import { Da6110Class } from '../../../../../Class/da6110/da6110-class';
import { Adm0006Class } from '../../../../../Class/ADM0006/adm0006-class';
import { WIDGET0004Class } from '../../../../../Class/WIDGET0004/widget0004-class';
import { WIDGET0005Class } from '../../../../../Class/WIDGET0005/widget0005-class';
import { WIDGET0004ServiceService } from '../../../../../Service/WIDGET0004/widget0004-service.service';
import { environment } from '../../../../../../environments/environment';
import { FileAttachmentComponent } from '../../../../pages/Hrms/common/file-attachment/file-attachment.component';
import { FileAttachmentInput } from '../../../../../Class/common/file-attachment/file-attachment-input';
import{Da9000Class}from '../../../../../Class/da9000/da9000-class';
import { Input, Inject,} from '@angular/core';
import { CommonService } from '../../../../../Service/common/common-service.service';
import { FileAttachDetailComponent } from '../FileAttachDetail/file-attach-detail.component';
@Component({
  selector: 'kt-widget0004',
  templateUrl: './widget0004.component.html',
  styleUrls: ['./widget0004.component.scss']
})
export class Widget0004Component   implements OnInit,AfterViewInit {

  dialogRef1:any;
  cdialogResult:any;
  objEmployeeListClass = new EmployeeListClass();
  Form:FormGroup;
  closeResult: string;
  MandatoryStatus: string;
  EmployeeList:Ba1300Class[];
  PayslipList:Adm0006Class[];
  CalenderList:any[];
  PaySlipList:any[];
  FkPerdIdList:any[];
  ValSelect:any;


  lblPageTitle: string = "";
  lblBack: string;
  lblClear: string;
  lblDelete: string;
  lblSave: string;
  lblSave_Exit: string;
  lblSave_Duplicate: string;
  lblSave_Continue: string;
  lblBack_to_Fin_Tool: string;
  lblClear_Changes_Tool: string;
  lblDelete_Selected_Entry_Tool: string;
  lblSave_Exit_Tool: string;
  lblDelMaster_Heading: string;
  lblDelMaster_Message: string;
  lblDelMaster_Progress_Message: string;
  lblDelMaster_Confirmation: string;
  lblDelMaster_Cancel: string;
  lblDelMasterDelete: string;
  lblConfirmTran: string;
  lblUserNam: string;
  lblUserLgnPwd: string;
  lblUserTrnPwd: string;
  lblFkFieldIdUserGroup: string;
  lblFkFieldIdUserType: string;
  lblFkEmpId:string;
  lblExternalUserName:string;
  lblActive:string;
  lblRemarks:string;
  lblValidUpTo:string;
  lblPortalUser:string;
  lblFkRoleId:string;
  lblFkCompId:string;
  lblConfirm:string;
  CtrlNames:any[];
  lblSelect:string;
  lblAdd:string;
  lblDuplication: string;
  lblMandatory: string;
  lblSystemError: string;

  // lblReferenceNo: string  
  lblTitle: string;
  lblMessages: string;
  lblTillDate:string;
  lblSendViaEmail: string;
  lblAttachment: string;
  lblSelectEmployees: string;
  lblSelectEmployeesToolTip: string;

  objFileAttachmentInput = new FileAttachmentInput();
  Errors:any[];
  count:number;
  private fieldArray: Array<any> = [];

  WIDGET0005List: Array<WIDGET0005Class> = [];
  objDa7420Service: any;

  constructor(public dialogRef: MatDialogRef<EmployeeListComponent>,private formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute,
    private objCommonService:CommonService, private objWIDGET0004ervice:WIDGET0004ServiceService,public dialog: MatDialog,private layoutUtilsService: LayoutUtilsService,private modalService: NgbModal, private changeDetectorRef: ChangeDetectorRef,@Inject(MAT_DIALOG_DATA) public ParamData: any ) {

  }
	ngOnInit() {
  
    var no=this.ParamData.AnnouncementId;

    this.DoFind(no);
       
     
   
    this.Form = this.formBuilder.group({
   
  
      AnnouncementId: [0, Validators.required],  
      Title: ['', Validators.required],
      Message: ['', Validators.required],
      TillDate: ['', Validators.required],
      SendViaEmail: ['', Validators.required],
      btnAttachment: ['', Validators.required],

    });

  }

  ngAfterViewInit()
  {
    
  }



  DoFind(AnnouncementId)
  {

    var classobj=new WIDGET0004Class();
    classobj.AnnouncementId = AnnouncementId;


    this.objWIDGET0004ervice.DoFind(AnnouncementId).subscribe(data=>{

      this.Form.controls["AnnouncementId"].setValue(data.AnnouncementId);
      this.Form.controls["Title"].setValue(data.Title);
      this.Form.controls["Message"].setValue(data.Messages);
     
    
      
      this.changeDetectorRef.detectChanges();
    })
    var objDa9000Class = new Da9000Class();   
    objDa9000Class.TableName="widget0004";
    objDa9000Class.AutoId = AnnouncementId;


    this.objCommonService.SelectAttachments(objDa9000Class).subscribe(data=>{
      if(data.length>0)
      {
        // var VarAnnounbementAttach =(<HTMLFormElement>document.getElementById("btnAttachment")) ;

        // VarAnnounbementAttach.hidden = true;

      }
      else{

        var VarAnnounbementAttach =(<HTMLFormElement>document.getElementById("btnAttachment")) ;

        VarAnnounbementAttach.hidden = true;

      }
 
          // this.fileList = data;
          this.changeDetectorRef.detectChanges();
       })
  }

  Close()
  {
    
    this.dialogRef.close(`${""}`);
  }
  onAttachment(OtherDocId, PageName, TableName)
  {


    if(OtherDocId == 0)
    {
      OtherDocId =  this.Form.controls["AnnouncementId"].value;
    }

    this.objFileAttachmentInput= new FileAttachmentInput();
    this.objFileAttachmentInput.FkPageId = 0;
    this.objFileAttachmentInput.PageName = PageName;
    this.objFileAttachmentInput.TableName = TableName;
    this.objFileAttachmentInput.AutoId = OtherDocId;

    this.dialogRef1=this.dialog.open(FileAttachDetailComponent, {
      width: '600px',height:'300px',
      data:this.objFileAttachmentInput
    });
    
    this.dialogRef1.afterClosed().subscribe(result => {
      if(result!= "")
      {
   
      }

      this.changeDetectorRef.detectChanges();
    }); 

  }




  
  getComponentTitle() 
  {

		let result = this.lblPageTitle;
		return result;
  }
 

  }









  



